module.exports = __webpack_public_path__ + "media/favicon/mstile-70x70-78c4b808.png";